<template>
  <div>
    <p class="content">
      Last, we need your billing information.
      Truckl charges $2.00 per load and additional fees apply for payments by invoice.
    </p>
    <payment-info  ref="form" v-model="paymentInfo" @isComplete="notify" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { isEmpty } from 'lodash-es'
import PaymentInfo from '@/components/FormPaymentInformation'
import CompanyApi from '@/api-interface/company'

export default {
  name: 'Registration-PaymentInfo',

  data() {
    return {
      paymentInfo: {}
    }
  },

  async created() {
    try {
      // first time this View is created... check for an existing company and kick them to dashboard if they already
      // have one, since it means they are done with registration.
      // await this.getCompanyDetails()
      // this.$router.push({ name: 'dashboard' })
    } catch (e) {
      // do nothing, just means they do not have a company
    }
  },

  async activated() {
    // because of the `<keep-alive>` tag used for the registration sub-views.... the "activated" hook gets called when
    // switching between sub-views. At that point we want to re-validate the form to make sure they can keep going.
    // The assumption is that it will already be filled out... so this is really just to make sure the "next" button is
    // enabled.

    if (this.currentCompanyInfo.companyKey) {
      const isValid = await this.$refs['form'].validate()

      if (isValid) {
        this.notify(true)
      }
    }
  },

  components: {
    PaymentInfo
  },

  computed: {
    ...mapState('user', { userInfo: 'currentUserInfo' }),
    ...mapState('company', ['currentCompanyInfo'])
  },

  methods: {
    ...mapActions('registration', ['registerCompany']),
    ...mapActions('company', { getCompanyDetails: 'getDetails' }),

    notify(isFormComplete) {
      this.$emit('canBeSubmitted', isFormComplete)
    },

    /**
     * Actually register the user/account
     * @returns {Promise<void>}
     */
    async register() {
      return CompanyApi.createSubscription({ billingInfo: this.paymentInfo })
    }
  },

  watch: {
    paymentInfo: {
      deep: true,
      handler() {
        if (
          (this.paymentInfo.doMonthlyInvoice || !isEmpty(this.paymentInfo.stripeSrcToken)) &&
          this.paymentInfo.acceptAgreements
        ) {
          this.notify(true)
        } else {
          this.notify(false)
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
